export default "__VITE_ASSET__c06f48be__"